import { render, staticRenderFns } from "./LayoutMenu.vue?vue&type=template&id=0277f344&"
import script from "./layoutMenu.js?vue&type=script&lang=js&"
export * from "./layoutMenu.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports